import {createContext, ReactNode, useContext, useEffect, useState} from 'react'
import {logger} from 'tizra'

const log = logger('useHydration')

const HydrationContext = createContext<{hydrating: boolean} | null>(null)

export const HydrationProvider = ({
  children,
  hydrate,
}: {
  children: ReactNode
  hydrate: boolean
}) => {
  const [hydrating, setHydrating] = useState<boolean>(hydrate)
  useEffect(() => setHydrating(false), [setHydrating])
  return (
    <HydrationContext.Provider value={{hydrating}}>
      {children}
    </HydrationContext.Provider>
  )
}

/**
 * Ensure consistency between SSR and initial render on client, so that
 * hydration works. See
 * https://github.com/smooth-code/xstyled/pull/114#issuecomment-690475156
 */
export const useHydration = <T, U>(before: T, after: U): T | U => {
  const context = useContext(HydrationContext)
  if (!context) {
    log.error('useHydration called outside of HydrationProvider')
    return after
  }
  return context.hydrating ? before : after
}
